export default __webpack_public_path__ + "static/aboutus-updated-4433759ab2820f35ffc00dc94e8582a3.jpg";